/* eslint-disable */
class AbstractProvider {
  constructor(videoId) {
    if (this.constructor === AbstractProvider) {
      throw Error('AbstractProvider cannot be instantiated');
    }
    this.videoId = videoId;
  }

  isThresholdReached() {
    throw Error('isThresholdReached function must be implemented');
  }

  newSecondsHaveElapsed() {
    throw Error('newSecondsHaveElapsed function must be implemented');
  }

  bind(event, callbackFn) {
    throw Error('bind function must be implemented');
  }

  unbind(event, callbackFn) {
    throw Error('unbind function must be implemented');
  }

  destroy() {
    throw Error('destroy function must be implemented');
  }
}

export default AbstractProvider;
